
import { ArrowLeftIcon } from "lucide-react";
import { Link } from "react-router-dom";
import AuthLayout from "@container/layout/auth";
import DemoInterviewForm from "@container/demo-interview-form";

export default function DemoInterviewEditPage() {

    return (
        <AuthLayout>
            <div
                className="min-h-screen bg-gray-50"
                style={{ backgroundColor: "#ffffff" }}
            >
                <div className="p-4">
                    {/* Header */}
                    <div className="mb-8">
                        <div className="flex items-center gap-4 mb-4">
                            <Link
                                to="/demo"
                                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
                            >
                                <ArrowLeftIcon className="h-5 w-5" />

                                <span>Back to Demo List</span>
                            </Link>
                        </div>
                        <h1 className="text-3xl font-bold text-gray-900">
                            Edit Company Demo
                        </h1>
                        <p className="text-gray-600 mt-2">
                            Update the demo link settings and branding for this company.
                        </p>
                    </div>

                    {/* Form */}
                    <DemoInterviewForm isEditMode />
                </div>
            </div>
        </AuthLayout>
    );
}
